module.exports = appJs;


/*****************
 ** WEBPACK FOOTER
 ** external "appJs"
 ** module id = 86
 ** module chunks = 0 1
 **/